import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import request from '@/utils/request'
import HomeView from '../views/HomeView.vue'
import AbountView from '../views/AboutView.vue'
import Login from '@/views/Login.vue'
import UserManage from '@/views/user/UserManage.vue'
import UserAuthSearch from '@/views/user/UserAuthSearch.vue'
import VIPManage from '@/views/user/VIPManage.vue'
import Profile from '@/views/user/Profile.vue'
import VIPCreate from '@/views/user/VIPCreate.vue'

import StatsCreationStyle  from '@/views/stats/StatsCreationStyle.vue'
import CreationSkill from '@/views/CreationSkill.vue'
import HomeBanner from '@/views/home_banner/HomeBanner.vue'
import Popup from '@/views/home_banner/Popup.vue'

import CreationStyle from '@/views/CreationStyle.vue'
import BanManage from '@/views/BanManage.vue'
import CreationOptions from '@/views/creation/CreationOptions.vue'
import CreationWorkManage from '@/views/creation/CreationWorkManage.vue'
import CompositionWorkList from '@/views/creation/CompositionWorkList.vue'
import CreationWorkReview from '@/views/creation/CreationWorkReview.vue'
import CreationTaskStyle from '@/views/creation/CreationTaskStyle.vue'
import CreationTaskTools from '@/views/creation/CreationTaskTools.vue'
import ImageTool from '@/views/tools/ImageTool.vue'
import RefundTool from '@/views/tools/refund.vue'
import CreationOperationTool from '@/views/creation/CreationOperationTool.vue'
import BatchCreate from '@/views/creation/BatchCreate.vue'

import i18nText from '@/views/i18n/i18nText.vue'
import CreationTabs from  '@/views/creation/CreationTabs.vue'
import UserStats from '@/views/stats/UserStats.vue'
import GenartionStats from '@/views/stats/GenerationStats.vue'
import TotalStats from '@/views/stats/TotalStats.vue'
import PaymentStats from '@/views/stats/PaymentStats.vue'
import YesterdayStats from '@/views/stats/YesterdayStats.vue'
import NewUserStats from '@/views/stats/NewUserCounts.vue'
import NewUserGrowth from '@/views/stats/NewUserGrowth.vue'
import NewRegionCounts from '@/views/stats/NewRegionCounts.vue'
import OrderSearch from '@/views/order/OrderSearch.vue'
import OrderTools from '@/views/order/OrderTools.vue'

import CommunityComment from '@/views/community/comment.vue'
import CommunityArticle from '@/views/community/article.vue'
import CommunityPostConfig from '@/views/community/post-config.vue'

import SensiWordVue from '@/views/SensiWord.vue'
import DeviceSearch from '@/views/device/DeviceSearch.vue'
import QueueStatus from '@/views/xae/queue/QueueStatus.vue'

import XaeExecutor from '@/views/xae/queue/Executor.vue'
import XaeMultiExecutor from '@/views/xae/queue/MultiExecutor.vue'
import SysCommonConfig from '@/views/sys/CommonConfig.vue'

import TestcaseCases from '@/views/testcase/Case.vue'
import TestcaseTasks from '@/views/testcase/Task.vue'
import TestcaseLabels from '@/views/testcase/Label.vue'
import TestcaseBatchs from '@/views/testcase/Batches.vue'
import TestcasePackages from '@/views/testcase/Packages.vue'
import TestcaseResources from '@/views/testcase/Resources.vue'
import TestcaseResourcesUpload from '@/views/testcase/ResourcesUpload.vue'
import TemplateScene from '@/views/template_scene/TemplateScene.vue'
import TemplateList from '@/views/template_scene/TemplateList.vue'
import OpSlots from '@/views/op_slots/OpSlots.vue'



const routes: any[] = [
  {
    path: '/xae',
    name: '/xae',
    component: HomeView,
    children: [
      {
        path: 'queue/executors',
        name: 'queue/executors',
        component:XaeExecutor,
        meta: {
          title: 'XAE-队列配置'
        }
      },{
        path: 'queue/multi',
        name: 'queue/multi',
        component: XaeMultiExecutor,
        meta: {
          title: 'XAE-多队列配置'
        }
      },{
        path: 'queue/status',
        name: 'queue/status',
        component: QueueStatus,
        meta: {
          title: 'XAE-队列状态'
        }
      },
    ]
  },
  {
    path: '/',
    alias: '/home',
    name: '',
    component: HomeView,
    children: [
      {
        path: 'admin/members',
        component: () => import('@/views/admin/Members.vue'),
        meta: { title: '成员管理', adminManagerOnly: true }
      },
      {
        path: 'admin/roles',
        component: () => import('@/views/admin/Roles.vue'),
        meta: { title: '角色管理', adminManagerOnly: true }
      },
      {
        path: 'about',
        name: 'about',
        component:AbountView
      },
      {
        path: 'user',
        name: 'user',
        component: UserManage,
        meta: {
          title: '用户管理'
        }
      },
      {
        path: 'vips',
        name: 'vips',
        component: VIPManage,
        meta: {
          title: 'VIP 管理'
        }
      },
      {
        path: 'vips/create',
        name: 'vips/create',
        component: VIPCreate,
        meta: {
          title: '创建 VIP'
        }
      },
      {
        path: 'home_banner',
        name: 'home_banner',
        component: HomeBanner,
        meta: {
          title: '首页banner'
        }
      },
      {
        path: 'popup',
        name: 'popup',
        component: Popup,
        meta: {
          title: '首页弹窗'
        }
      },
      {
        path: 'creation/works',
        name: 'creation/works',
        component: CreationWorkManage,
        meta: {
          title: '创作管理'
        }
      },
      {
        path: 'creation/composition-works',
        name: 'creation/composition-works',
        component: CompositionWorkList,
        meta: {
          title: '构图作品列表'
        }
      },
      {
        path: 'creation/works/review',
        name: 'creation/works/review',
        component: CreationWorkReview,
        meta: {
          title: '作品审核'
        }
      },{
        path: 'creation/style',
        name: 'creation/style',
        component: CreationTaskStyle,
        meta: {
          title: '创作类型说明'
        }
      },
      {
        path: 'creation/tools',
        name: 'creation/tools',
        component: CreationTaskTools,
        meta: {
          title: '创作工具',
          key: '/tools'
        }
      },
      {
        path: 'creation/image_tools',
        name: 'creation/image_tools',
        component: ImageTool,
        meta: {
          title: '图片工具',
          key: '/tools'
        }
      },
      {
        path: 'creation/refund_tools',
        name: 'creation/refund_tools',
        component: RefundTool,
        meta: {
          title: '退款工具',
          key: '/tools'
        }
      },
      {
        path: 'creation/operation_tool',
        name: 'creation/operation_tool',
        component: CreationOperationTool,
        meta: {
          title: '运营工具'
        }
      },
      {
        path: 'creation/style',
        name: 'creation/style',
        component: CreationStyle,
        meta: {
          title: '创作风格'
        }
      },
      {
        path: 'creation/stats/style',
        name: 'creation/stats/style',
        component: StatsCreationStyle,
        meta: {
          title: '创作风格统计'
        }
      },
      {
        path: 'creation/sskills',
        name: 'creation/sskills',
        component: CreationSkill,
        meta: {
          title: '创作技能'
        }
      },
      {
        path: 'creation/options',
        name: 'creation/options',
        component: CreationOptions,
        meta: {
          title: '创作模板配置'
        }
      },
      {
        path: 'creation/batch-create',
        name: 'creation/batch-create',
        component: BatchCreate,
        meta: {
          title: '批量创建模板'
        }
      },
      {
        path: 'creation/tabs',
        name: 'creation/tabs',
        component: CreationTabs,
        meta: {
          title: '创作Tabs配置'
        }
      },
      {
        path: 'user/ban_manage',
        name: 'user/ban_manage',
        component: BanManage,
        meta: {
          title: '用户封禁管理'
        }
      },
      {
        path: 'anti/sensiword',
        name: 'anti/sensiword',
        component: SensiWordVue,
        meta: {
          title: '敏感词管理'
        }
      },
      {
        path: 'user/stats',
        name: 'user/stats',
        component: UserStats,
        meta: {
          title: '用户统计'
        }
      },
      {
        path: 'user/auth',
        name: 'user/auth',
        component: UserAuthSearch,
        meta: {
          title: '用户权限管理'
        }
      },
      {
        path: 'user/profile',
        name: 'user/profile',
        component: Profile,
        meta: {
          title: '用户信息探测'
        }
      },
      {
        path: 'i18n/text',
        name: 'i18n/text',
        component: i18nText,
        meta: {
          title: '国际化文本'
        }
      },{
        path: 'testcase/cases',
        name: 'testcase/cases',
        component: TestcaseCases,
        meta: {
          title: '测试用例'
        }
      },{
        path: 'testcase/tasks',
        name: 'testcase/tasks',
        component: TestcaseTasks,
        meta: {
          title: '测试结果'
        }
      },{
        path: 'testcase/batchs',
        name: 'testcase/batchs',
        component: TestcaseBatchs,
        meta: {
          title: '测试'
        }
      },{
        path: 'testcase/labels',
        name: 'testcase/labels',
        component: TestcaseLabels,
        meta: {
          title: '测试打标'
        }
      },{
        path: 'testcase/packages',
        name: 'testcase/packages',
        component: TestcasePackages,
        meta: {
          title: '素材包管理'
        }
      },{
        path: 'testcase/packages/resources',
        name: 'testcase/packages/resources',
        component: TestcaseResources,
        meta: {
          title: '素材管理'
        }
      },
      {
        path: 'testcase/packages/resources/upload',
        name: 'testcase/packages/resources/upload',
        component: TestcaseResourcesUpload,
        meta: {
          title: '素材上传'
        }
      },
       {
        path: 'community/article',
        name: 'community/article',
        component: CommunityArticle,
        meta: {
          title: '社区主贴'
        }
      },
       {
        path: 'community/comment',
        name: 'community/comment',
        component: CommunityComment,
        meta: {
          title: '社区评论'
        }
      },
       {
        path: 'community/post-config',
        name: 'community/post-config',
        component: CommunityPostConfig,
        meta: {
          title: '帖子模板配置'
        }
      },
       {
        path: 'sys/common_config',
        name: 'sys/common_config',
        component: SysCommonConfig,
        meta: {
          title: '通用配置'
        }
      },
      {
        path: 'stats/total',
        name: 'stats/total',
        component: TotalStats,
        meta: {
          title: '整体统计'
        }
      },
      {
        path: 'stats/payment',
        name: 'stats/payment',
        component: PaymentStats,
        meta: {
          title: '付费率统计'
        }
      },
      {
        path: 'stats/yesterday',
        name: 'stats/yesterday',
        component: YesterdayStats,
        meta: {
          title: '昨日数据'
        }
      },
      {
        path: 'stats/generation',
        name: 'stats/generation',
        component: GenartionStats,
        meta: {
          title: '昨日创作数据'
        }
      },{
        path: 'stats/new_user_counts',
        name: 'stats/new_user_counts',
        component: NewUserStats,
        meta: {
          title: '用户数据统计'
        }
      },{
        path: 'stats/new_user_regions',
        name: 'stats/new_user_regions',
        component: NewRegionCounts,
        meta: {
          title: '用户数据统计(全球)'
        }
      },{
        path: 'stats/new_user_growth',
        name: 'stats/new_user_growth',
        component: NewUserGrowth,
        meta: {
          title: '新增用户增长数据'
        }
      },{
        path: 'device/search',
        name: 'device/search',
        component: DeviceSearch,
        meta: {
          title: '设备搜索'
        }
      },{
        path: 'order/search',
        name: 'order/search',
        component: OrderSearch,
        meta: {
          title: '订单搜索'
        }
      },{
        path: 'order/tools',
        name: 'order/tools',
        component: OrderTools,
        meta: {
          title: '订单工具',
          key: '/tools'
        }
      },
      {
        path: 'template_scene',
        name: 'template_scene',
        component: TemplateScene,
        meta: {
          title: '模板场景管理'
        }
      },
      {
        path: 'template_scene/:sceneId/templates',
        name: 'template_scene/templates',
        component: TemplateList,
        props: true,
        meta: {
          title: '场景模板列表'
        }
      },
      {
        path: 'op_slots',
        name: 'op_slots',
        component: OpSlots,
        meta: {
          title: '运营位管理'
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.adminManagerOnly)) {
    try {
      // Refresh before checking: Vuex can be empty on reload or stale after a role change.
      const response = await request.post('/api/account/auth') as {code: number; data: {user_role: number}}
      if (response.code !== 0 || !response.data) { next('/login'); return }
      store.commit('setLogin', response.data)
      if (![1, 4].includes(Number(response.data.user_role))) { next('/home'); return }
    } catch (e) { next('/login'); return }
  }
  // 如果路由元信息中有 title，则设置页面标题
  if (to.meta && to.meta.title) {
    document.title = `炫图后台-${to.meta.title}`
  } else {
    document.title = '炫图管理后台' // 如果没有定义 title，使用默认标题
  }
  next()
})

export default router
